import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { I18nModule, provideConfig } from '@spartacus/core'
import { IconModule, MediaModule } from '@spartacus/storefront'
import { EbCountrySelectionComponent } from '../site-context/site-context-selector/eb-country-selection.component'
import { EbSiteContextSelectorComponent } from '../site-context/site-context-selector/eb-site-context-selector.component'
import { EbSearchBoxComponent } from './components/search-box/eb-search-box.component'
import { EbSearchBoxModule } from './components/search-box/eb-search-box.module'
import { ebHeaderLayoutConfig } from './eb-header-layout.config'

@NgModule({
  imports: [
    CommonModule,
    IconModule,
    I18nModule,
    EbSearchBoxModule,
    MediaModule,
    EbCountrySelectionComponent,
    EbSiteContextSelectorComponent
  ],
  providers: [
    provideConfig(ebHeaderLayoutConfig),
    provideConfig({
      cmsComponents: {
        SearchBoxComponent: {
          component: EbSearchBoxComponent
        },
        CountrySelectionComponent: {
          component: EbCountrySelectionComponent
        }
      }
    })
  ]
})
export class EbHeaderModule {}
